/**
 * Layout: Aanmeldformulier
 * Slug: aanmeld_formulier
 */

// Opened without a valid activiteit: back to the archive
const initAanmeldFormulier = () => {
    const layout = document.querySelector(".aanmeld_formulier-layout[data-redirect-url]");
    if (layout) window.location.replace(layout.dataset.redirectUrl);
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAanmeldFormulier);
} else {
    initAanmeldFormulier();
}
